var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        directives: [
          {
            name: "hover-intent",
            rawName: "v-hover-intent:[hoverTimeout]",
            value: _vm.action,
            expression: "action",
            arg: _vm.hoverTimeout,
          },
        ],
        ref: "button",
        staticClass: "icon w-btn w-btn-icon",
        class: [_vm.size, _vm.classes],
        attrs: { href: "#" },
      },
      _vm.listeners
    ),
    [
      _vm._t("default", function () {
        return [
          _c("span", {
            staticClass: "dashicons",
            class: "dashicons-" + _vm.icon,
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }